module.exports = __webpack_public_path__ + "static/industry-leader-7d5824799a5f5b7d4ae5d5f3b53d11de.jpg";